export interface Location {
  latitude: number
  longitude: number
  name?: string
  address?: string
}

export interface SearchResult {
  name: string
  address?: string
  latitude: number
  longitude: number
  type?: string
}

export interface RouteStep {
  id: string
  type: "walking" | "trotro" | "driving"
  instruction: string
  duration: number
  distance: number
  from?: string
  fromStopId?: string
  to?: string
  toStopId?: string
  fare?: number
  coordinates?: number[][]
  routeNumber?: string
  routeId?: string
  routeName?: string
  stops?: string[]
  color?: string
  routeIndex?: number
  scheduled?: boolean
  durationP10?: number
  durationP90?: number
  confidence?: number
  headwayMinSecs?: number
  headwayMaxSecs?: number
}

export interface RouteOption {
  id: string
  type: "fastest" | "cheapest" | "shortest" | "recommended"
  title: string
  totalTime: number
  totalDistance: number
  totalPrice: number
  transfers: number
  steps: RouteStep[]
  coordinates: number[][]
  totalP10?: number
  totalP90?: number
  confidence?: number
  headwayMinSecs?: number
  headwayMaxSecs?: number
}

export interface Station {
  id: string
  name: string
  lat: number
  lon: number
}

export interface StationRoute {
  id: string
  shortName: string
  longName: string
}

export interface StationDetails {
  stop: Station
  routes: StationRoute[]
}

export interface VehiclePosition {
  route_id: number
  lat: number
  lng: number
  heading: number
  speed_kmh: number
  updated_at: number
}

export interface ContactInfo {
  phone?: string
  email?: string
  website?: string
}

export interface PublicEvent {
  id: string
  title: string
  description: string | null
  event_type: string
  lat: number
  lon: number
  venue_name: string | null
  address: string | null
  start_time: string
  end_time: string
  all_day: boolean | null
  cover_image_url: string | null
  images: string[] | null
  organizer: string | null
  contact_info: ContactInfo | null
  price_info: string | null
  capacity: number | null
  attendee_count: number | null
  nearest_stop_id: string | null
  recommended_routes: string[] | null
  created_by: string
  verified: boolean | null
  status: string | null
  created_at: string
  updated_at: string
}

export interface EventsResponse {
  data: PublicEvent[]
  total: number
  limit: number
  offset: number
}

export type EventType =
  | "concert"
  | "festival"
  | "sports"
  | "market"
  | "religious"
  | "community"
  | "other"

export const EVENT_TYPE_COLORS: Record<EventType, string> = {
  concert: "#8b5cf6",
  festival: "#ec4899",
  sports: "#10b981",
  market: "#f59e0b",
  religious: "#6366f1",
  community: "#06b6d4",
  other: "#3b82f6",
}

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  concert: "Concert",
  festival: "Festival",
  sports: "Sports",
  market: "Market",
  religious: "Religious",
  community: "Community",
  other: "Other",
}

export function getEventColor(eventType: string): string {
  return EVENT_TYPE_COLORS[eventType as EventType] || EVENT_TYPE_COLORS.other
}

export function getEventLabel(eventType: string): string {
  return EVENT_TYPE_LABELS[eventType as EventType] || "Event"
}
